import { Communication } from 'models/install-verification-tags/tag/communication/Communication';
import { isTimeOlderThanThreshold } from 'utils/dates';
import { sntConfig } from 'models/install-verification-tags/device-config/slap-and-track-config';
import { INSTALL_VERIFICATION_CONSTANTS } from 'app/utils/install-verification-tag-constants';
import {
  StatusType,
  StatusTypeDescriptor,
  StatusTypeToken,
  TagType,
} from 'models/install-verification-tags/types';
import type {
  ITag,
  IInstallVerificationTagData,
  ITagStatus,
} from 'models/install-verification-tags/types';

export class SlapAndTrackCommunication extends Communication {
  constructor(tagType: TagType, tagData: IInstallVerificationTagData) {
    super(tagType, tagData);
  }

  private determineStatus(): void {
    const timeoutThreshold = sntConfig.health.communication.checkinTimeout;

    // No communication data available or invalid datetime
    if (!this.isValidLastCheckinData()) {
      this.statusDetail = INSTALL_VERIFICATION_CONSTANTS.COMMUNICATION_STATUS.NO_COMMUNICATION;
      this.statusType = StatusType.DANGER;
      return;
    }

    // Check if communication is within acceptable timeframe
    const hasCommunicationTimeoutExpired = isTimeOlderThanThreshold(
      this.lastCheckin!,
      timeoutThreshold,
      'hours'
    );

    if (hasCommunicationTimeoutExpired) {
      this.statusDetail = INSTALL_VERIFICATION_CONSTANTS.COMMUNICATION_STATUS.TIMEOUT_EXCEEDED;
      this.statusType = StatusType.DANGER;
    } else {
      this.statusDetail = INSTALL_VERIFICATION_CONSTANTS.COMMUNICATION_STATUS.ACTIVE;
      this.statusType = StatusType.SUCCESS;
    }
  }

  getStatus(): ITagStatus {
    this.determineStatus();

    return {
      status: this.statusType,
      statusToken: StatusTypeToken[this.statusType],
      statusDescriptor: StatusTypeDescriptor[this.statusType],
    };
  }

  createTag(): ITag {
    const statusMeta = this.getStatus();
    return {
      ...this.defaults,
      status: statusMeta.status,
      statusToken: statusMeta.statusToken,
      tagText: SlapAndTrackCommunication.getTagTextTemplate(
        this.tagType,
        statusMeta.statusDescriptor
      ),
      description: this.statusDetail,
    };
  }
}
